// extracted by mini-css-extract-plugin
export var eventsCalendar = "calendar-module--events-calendar--l5UA9";
export var eventsContact = "calendar-module--events-contact--2zPU0";
export var eventsHeader = "calendar-module--events-header---1js2";
export var eventsRegHeader = "calendar-module--events-reg-header--soTBT";
export var eventsRoomLegend = "calendar-module--events-room-legend--o02nJ";
export var regularEventWrapper = "calendar-module--regular-event-wrapper--RIuUV";